import Image from "next/legacy/image";

import * as S from "./FunnelLnb.style";
import logo_white from "/public/images/landing/lnb/logo_web_GNB_white.svg";
import logo_black from "/public/images/landing/lnb/logo_web_GNB_black.svg";

type Props = {
  isWhite?: boolean;
};

const FunnelLnb = ({ isWhite }: Props) => {
  return (
    <S.Background isWhite={isWhite}>
      <S.Wrapper>
        <S.Image>
          <Image src={isWhite ? logo_black : logo_white} alt="logo" />
        </S.Image>
        <S.Empty />
      </S.Wrapper>
    </S.Background>
  );
};

export default FunnelLnb;
